// extracted by mini-css-extract-plugin
export var footer = "_lw-0";
export var inherit = "_lw-1";
export var input = "_lw-2";
export var modalContent = "_lw-3";
export var quillEditor = "_lw-4";
export var subtitle = "_lw-5";